import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { toggleClaimPopup } from 'Redux/PopupSlice/PopupSlice';
const useShortcutKeys = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.altKey) {
                switch (
                event.key.toLowerCase() // Ensure case insensitivity
                ) {
                    case 'c': {
                        // Alt + C for claim popup
                        event.preventDefault();
                        dispatch(toggleClaimPopup(true));
                        break;
                    }


                    default: {
                        break;
                    }
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [dispatch]);
};

export default useShortcutKeys;